import MentorSignup03 from '../components/signuppage/MentorSignup03';

const MentorSignup03Page = () => {
    return (
        <>
            <MentorSignup03 />
        </>
    );
};

export default MentorSignup03Page;
